/**
 * Resolve the Shelly Cloud API base URL the page should talk to.
 *
 * Mirrors the legacy `oauth_login.js` logic so a single deployed artifact
 * picks the correct backend per environment, with no Vite env-var builds.
 *
 * Host map:
 *   repo.shelly.cloud / mytest.shelly.cloud  -> https://repo.shelly.cloud   (debug)
 *   anything else                            -> https://api2.shelly.cloud   (prod)
 *
 * Email override (legacy easter egg):
 *   nb@allterco.com                          -> https://nb.shelly.cloud     (experimental)
 *
 * Both functions are pure and take their inputs explicitly so they're unit-testable
 * without touching `window`.
 */

const PROD_BASE = 'https://api2.shelly.cloud';
const REPO_BASE = 'https://repo.shelly.cloud';
const NB_BASE = 'https://nb.shelly.cloud';

const DEBUG_HOSTS = new Set(['repo.shelly.cloud', 'mytest.shelly.cloud']);

/**
 * Base URL chosen from the browser host.
 * Pass an explicit host for tests; defaults to `window.location.host`.
 */
export function resolveBaseUrl(host: string = readHost()): string {
	if (DEBUG_HOSTS.has(host)) return REPO_BASE;
	return PROD_BASE;
}

/**
 * Override hook for the `nb@allterco.com` experimental backend.
 * The legacy page asks the user to confirm via alert; we keep the override
 * silent here and surface a banner in the UI layer instead.
 */
export function resolveBaseUrlForEmail(email: string, host: string = readHost()): string {
	if (email.toLowerCase() === 'nb@allterco.com') return NB_BASE;
	return resolveBaseUrl(host);
}

function readHost(): string {
	if (typeof window === 'undefined') return '';
	return window.location.host;
}
